import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { NetworkIcon, TrendingDownIcon, SearchIcon } from 'lucide-react';
const pains = [{
  icon: NetworkIcon,
  title: 'De Hengelaar 🎣',
  body: 'Je hebt geen echte online aanwezigheid. Je leeft van doorverwijzingen en vangt alleen wat toevallig langskomt. Maar je via-via netwerk droogt op, en nieuwe klanten van buitenaf werven lukt niet.',
  accent: '#FF5F57'
}, {
  icon: TrendingDownIcon,
  title: 'De Kreeftvanger 🦞',
  body: "Je hebt een kleine website, een paar pagina's, één plek. Je hebt geïnvesteerd in ads of een marketingbureau, maar het leverde weinig op. De kosten waren hoog, het bewijs ontbrak.",
  accent: '#FEBC2E'
}, {
  icon: SearchIcon,
  title: 'De Optimist met Sleepnet 🥅',
  body: 'Je hebt een grote website laten bouwen door een bureau op basis van aannames en zoekvolume. Een groot net, maar op de verkeerde plek. Je ziet door de bomen het bos niet meer en weet niet waar je moet beginnen met je zichtbaarheid.',
  accent: '#0066FF'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15,
      delayChildren: 0.2
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 40,
    scale: 0.95
  },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: {
      type: 'spring',
      stiffness: 100,
      damping: 15
    }
  }
};
export function PainPoints() {
  const ref = useRef(null);
  const inView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="py-20 bg-white" data-id="element-320">
      <div className="max-w-[1200px] mx-auto px-6" data-id="element-321">
        <motion.div className="text-center mb-14" initial={{
        opacity: 0,
        y: 30
      }} animate={inView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6,
        type: 'spring',
        stiffness: 100
      }} data-id="element-322">
          <div className="section-label" data-id="element-323">Herken je dit?</div>
          <h2 className="text-[clamp(2.2rem,4vw,3.2rem)] font-black text-brand-dark leading-tight tracking-tight" data-id="element-324">
            Welke visser
            <br data-id="element-325" />
            <span className="text-brand-primary" data-id="element-326">ben jij?</span>
          </h2>
        </motion.div>

        <motion.div className="grid md:grid-cols-3 gap-6" variants={containerVariants} initial="hidden" animate={inView ? 'visible' : 'hidden'} data-id="element-327">
          {pains.map(pain => <motion.div key={pain.title} className="card group cursor-default" variants={itemVariants} whileHover={{
          y: -8,
          transition: {
            type: 'spring',
            stiffness: 300,
            damping: 20
          }
        }} data-id="element-328">
              <motion.div className="w-14 h-14 rounded-2xl flex items-center justify-center mb-7" style={{
            background: `${pain.accent}15`,
            border: `1px solid ${pain.accent}30`
          }} whileHover={{
            scale: 1.1,
            rotate: 5,
            transition: {
              type: 'spring',
              stiffness: 300
            }
          }} data-id="element-329">
                <pain.icon size={24} style={{
              color: pain.accent
            }} data-id="element-330" />
              </motion.div>
              <h3 className="font-black text-xl text-brand-dark mb-4 group-hover:text-brand-primary transition-colors duration-300" data-id="element-331">
                {pain.title}
              </h3>
              <p className="text-brand-gray leading-relaxed text-[0.98rem]" data-id="element-332">{pain.body}</p>
              <motion.div className="mt-7 h-1 w-16 rounded-full" style={{
            background: `linear-gradient(90deg, ${pain.accent}, transparent)`
          }} initial={{
            width: '4rem'
          }} whileHover={{
            width: '100%',
            transition: {
              duration: 0.5,
              ease: 'easeOut'
            }
          }} data-id="element-333" />
            </motion.div>)}
        </motion.div>

        {/* Transition text */}
        <motion.p className="text-center mt-16 text-[1.15rem] text-brand-gray max-w-[640px] mx-auto leading-relaxed" initial={{
        opacity: 0,
        y: 20
      }} animate={inView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6,
        delay: 0.6,
        type: 'spring'
      }} data-id="element-334">
          Er is een vierde manier, onze manier.{' '}
          <strong className="text-brand-dark font-black" data-id="element-335">De visser met sonar.</strong>
        </motion.p>
      </div>
    </section>;
}